import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { blackPvcDictVi } from "@/lib/shop/products/black-pvc";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/shop_/black-pvc")({
  head: () => ({
    ...buildProductHead(blackPvcDictVi),
    links: alternateLinkList("/shop/black-pvc", "vi"),
  }),
  component: () => <ProductPage dict={blackPvcDictVi} />,
});